<template>
  <v-container
    class="my-12"
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        md="8"
      >
        <v-card>
          <v-card-title primary-title class="text-center display-1">
            <v-col>
              <v-icon x-large class="blue--text text--darken-2">
                mdi-account
              </v-icon><br>
              Log-in
            </v-col>
          </v-card-title>
          <v-card-text>
            <v-text-field
              :rules="emailRules"
              :error-messages="errorMessageEmail"
              v-model="email"
              prepend-icon="mdi-email"
              type="email"
              name="E-Mail"
              label="E-Mail-Adresse"
              required
            />

            <v-text-field
              v-model="password"
              :type="showPW ? 'password' : 'text'"
              @click:append="() => (showPW = !showPW)"
              :append-icon="showPW ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="passwordRules"
              :error-messages="errorMessagePassword"
              prepend-icon="mdi-security"
              hint="Passwort eingeben"
              name="Passwort"
              label="Passwort"
              required
            />

            <my-alert
              v-if="this.$store.state.error"
              :error="this.$store.state.error"
              :title="this.$store.state.errorTitle"
              :show-verify-link="this.$store.state.loginRegisterStore.showVerifyLink"
              type="error"
            />
            <v-card-actions>
              <v-btn
                :loading="this.$store.state.loading"
                outlined
                large
                block
                class="primary--text"
                @click.native.stop="gameLogin()"
              >
                Einloggen <v-icon right class="blue--text text--darken-2">
                  mdi-login
                </v-icon>
              </v-btn>
            </v-card-actions>
            <br>
            <p class="text-center">
              <router-link to="/register">
                Neu hier? Dann registriere Dich hier kostenlos für den Kegelmanager!
              </router-link>
            </p>
            <p class="text-center">
              <router-link to="/reset-password">
                Passwort vergessen? Dann hier ein neues anfordern.
              </router-link>
            </p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { ROOT_LOADING } from '../../store/mutation-types'
const emailCheck = require('../../vendor/checkEmail')

export default {
  name: 'Login',
  metaInfo: {
    title: 'Log-in'
  },
  data () {
    return {
      showPW: true,
      email: '',
      password: '',
      loginProcess: false,
      validEmail: false,
      emailRules: [],
      passwordRules: [],
      errorMessageEmail: [],
      errorMessagePassword: []
    }
  },
  async created () {
    await this.$store.dispatch('matchEvaluationInProgress')
    // check if user is already logged in and then redirect to home
    if (this.$store.state.loggedIn || this.$store.state.matchEvaluationInProgress) {
      this.$router.replace({ path: '/' })
    }
  },
  methods: {
    validateAll: (email, password) => {
      const ret = { status: true }
      if (!emailCheck(email)) {
        ret.email = true
        ret.status = false
      }
      if (password.length == null || password.length < 1) {
        ret.password = true
        ret.status = false
      }
      return ret
    },
    gameLogin: async function () {
      this.$store.commit(ROOT_LOADING, true)
      const check = this.validateAll(this.email, this.password)
      this.emailRules = []
      this.passwordRules = []
      this.errorMessageEmail = []
      this.errorMessagePassword = []
      if (!check.status) {
        // show errors
        this.loginProcess = false
        if (check.email) {
          this.emailRules = ['Fehlerhafte E-Mail-Adresse!']
          this.errorMessageEmail = ['Fehlerhafte E-Mail-Adresse!']
        }
        if (check.password) {
          this.passwordRules = ['Passwort ist falsch!']
          this.errorMessagePassword = ['Passwort ist falsch!']
        }
        this.$store.commit(ROOT_LOADING, false)
        return false
      }

      this.$store.commit('loginRegisterStore/AUTH_SET_LOGIN_EMAIL', this.email)
      const loggedIn = await this.$store.dispatch('loginRegisterStore/loginUser', {
        email: this.email,
        password: this.password
      })
      if (loggedIn && this.$store.state.loggedIn) {
        this.$router.replace({ path: '/buero' })
      }
    }
  }
}
</script>
